export default __webpack_public_path__ + "f062b1e.png";